export default __webpack_public_path__ + "static/media/LogoAutomato 1.8e0c07f8.png";